import React from "react";

import {EDocumentTypes} from "@/components/project/models";
import display from "@/services/display-name";
import {ERoles} from "@/services/models";
import session from "@/services/session";

import DocumentLink from "./DocumentLink";

interface IUserLinkProps {
    username: string;
    displayName?: string;
    documentType: EDocumentTypes.User | EDocumentTypes.Group;
    highlighter?: string;
}

interface IUserLinkState {
    displayName: string;
}

class UserLink extends React.PureComponent<IUserLinkProps, IUserLinkState> {
    public readonly state: IUserLinkState = {
        displayName: this.props.displayName ?? "",
    };

    public async componentDidMount() {
        await this.updateName();
    }

    public async componentDidUpdate(prevProps: Readonly<IUserLinkProps>) {
        await this.updateName(prevProps.username !== this.props.username);
    }

    public render() {
        const {username, documentType, highlighter} = this.props;
        const {displayName} = this.state;

        const id = documentType === EDocumentTypes.User ? "user" : "group";
        let type: EDocumentTypes = documentType;
        if (!session.hasRole(ERoles.Administrator)) {
            type = EDocumentTypes.Unknown;
        }

        return (
            <DocumentLink
                idSuffix={id + "-link"}
                value={{id: username, name: displayName, type, project: 0}}
                highlighter={highlighter}
            />
        );
    }

    private async updateName(forceUpdate: boolean = false) {
        const {username, displayName} = this.props;
        if (this.state.displayName === "" || forceUpdate) {
            this.setState({
                displayName:
                    displayName ?? (await display.getDisplayName(username)),
            });
        }
    }
}

export default UserLink;
